import { Observable } from "rxjs"
import GovPoolStatisticsDetails from "./RandomsModel/GovPoolStatisticsDetails"
import { ObservableFromFetch } from "../ObservableFromFetch"

export default function GovPoolStatisticsDetailsGetObservable(poolId: number): Observable<GovPoolStatisticsDetails[]> {
  const requestBody: string = new URLSearchParams({
    govPoolId: poolId.toString()
  }).toString()

  return ObservableFromFetch<GovPoolStatisticsDetails[]>("GovPool/GetGovPoolStatistics?" + requestBody)
}
